/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface ICollegePlanningScope extends ng.IScope {
        vm: CollegePlanning;
        actions: any;
        reasons: any;
        dateOptions: any;
    }

    interface ICollegePlanning {
    }

    interface EnrollReason { id: number; name: string; }

    interface IntentEnroll {
        id: number;
        userID: any;
        organizationID: any;
        collegeName: any;
        collegeCity: any
        savedDate: any;
        reasonNotes: any;
        hasCampusProfile: boolean;
        campusURL: string;
        reasons: Array<EnrollReason>;
    }

    interface TransitionPlan {
        id: number;
        pathType: any;
        planDescriptionNotes: any;
        careerGoalNotes: any;
        supportNotes: any;
        nextTransitionNotes: any;
        savedDate: any;
    }

    interface PersonalStatement {
        id: number;
        userId: number;
        draftFileName: string;
        draftFileLocation: string;
        DraftFileData: any;
        finalFileName: string;
        finalFileLocation: string;
        FinalFileData: any;
    }


    class CollegePlanning implements ICollegePlanning {
        static $inject: Array<string> = ["config", "$uibModal", "common", "Restangular", "$scope", "$document", "$http", "Upload", "savedSearchService", "$location", "helper"];
        static controllerId: string = "collegePlanning";
        private log;
        userID: any;
        noSavedSearches: boolean;
        show: string;
        trackAction: boolean;
        addNotes: boolean;
        addCampusNotes: boolean;
        enrollList: boolean;
        identifyCollege: boolean;
        collegeReasons: boolean;
        intendedSchool: boolean;
        programList: boolean;
        chosenProgram: boolean;
        addProgramNotes: boolean;
        selfReport: boolean;
        createPlan: boolean;
        planSummary: boolean;
        planList: boolean;
        selfReportApp: boolean;
        showProgramNotes: boolean;
        notes: string;
        intentEnrollNotes: string;
        savedProgramNotes: string;
        selfReportID: any;
        selfReportName: string;
        selfReportCity: string;
        selfReportIndex: number;
        reasonsSelected: Array<string>;
        actions: any;
        reasons: any;
        savedSearches: any;
        draftStatment: any;
        finalStatement: any;
        foundRecruiters: boolean;
        showSelfApps: boolean;
        applicationDates: any;
        intentEnrollSchoolInfo: IntentEnroll;
        personalStatements: any;
        savedSearchList: Array<any>;
        savedProgramsMajors: any;
        selfReportedApps: any;
        savedColleges: any;
        savedRecruiters: Array<any>;
        schoolList: any = [];
        transitionPlan: TransitionPlan;
        srDate: Date;
        opened: boolean;
        newDate: Date;
        enrollLoading: boolean;
        loadTransition: boolean;
        loadPersonal: boolean;
        institutionList: any;
        noSavedColleges: boolean;
        organizationID: any;
        verifiedSchool: boolean;
        verifiedSelfReportSchool: boolean;
        data: PersonalStatement;
        environmentURL: string;
        maxDate: any;
        intendedCollegeName: string;
        intendedReasons: Array<EnrollReason>;
        intendedReasonNotes: string;

        tempPlanDescriptionNotes: string;
        tempCareerGoalNotes: string;
        tempSupportNotes: string;
        tempNextTransitionNotes: string;
        tempPathType: string;
        logSuccess: (msg, data?, showHowl?) => void;
        logError: (msg, data?, showHowl?) => void;
        pdfButtonDisable: boolean;
        emailButtonDisable: boolean;
        draftStatementName: string;
        finalStatementName: string;
        uploadedDraft: boolean;
        uploadedFinal: boolean;
        showDraftCancel: boolean;
        showFinalCancel: boolean;
        apiHost: any;
        draftFile: any;
        finalFile: any;
        savedSearchComments: any;
        savedCollegeComments: any;
        savedProgramsComments: any;
        selfReportedComments: any;
        minDate: Date;
        minDateDisplay: string;

        constructor(private config: IConfig, private $uibModal: ng.ui.bootstrap.IModalService, private common: ICommonFactory, private Restangular: Restangular.IService, private $scope: ICollegePlanningScope, private $document: ng.IDocumentService, private $http: any, private Upload, private savedSearchService: IsavedSearchService, private $location: ng.ILocationService, private helper: IHelper) {
            this.log = common.logger.getLogFn(CollegePlanning.controllerId);
            this.logSuccess = this.common.logger.getLogFn(CollegePlanning.controllerId, "success");
            this.logError = this.common.logger.getLogFn(CollegePlanning.controllerId, "error");
            this.userID = 0;
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });

            this.show = 'CampusSearch';
            this.enrollList = true;
            this.programList = false;
            this.planList = true;
            this.intentEnrollNotes = "None";
            this.savedProgramNotes = "";
            this.srDate = new Date();
            this.maxDate = new Date();
            this.minDate = new Date(1899, 12);
            this.minDateDisplay = this.maxDate.toLocaleDateString();
            this.opened = false;
            this.verifiedSchool = true;
            this.verifiedSelfReportSchool = true;
            this.apiHost = this.config.apiHost;
            $scope.dateOptions = {
                showWeeks: false
            };
        }

        open() {
            this.opened = true;
            var test = this.srDate;
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, CollegePlanning.controllerId)
                .then(() => {
                    this.log("Activated College Planning");
                    this.noSavedSearches = false;
                    this.enrollLoading = true;
                    this.loadTransition = true;
                    this.loadPersonal = true;
                    this.emailButtonDisable = false;
                    this.pdfButtonDisable = false;
                    this.showDraftCancel = false;
                    this.showFinalCancel = false;
                    this.getSavedSearches();
                    this.getIntentEnrollSchool();
                    this.getTransitionPlan();
                    this.getSavedProgramsMajors();
                    this.getSelfReportedApps();
                    this.getSavedColleges();
                    this.getCollegeRecuiters();
                    this.getPersonalStatements();
                    this.environmentURL = this.config.transitionsUrl;


                    this.actions = [{ id: 1, name: "Visited the Campus" },
                        { id: 2, name: "Financial Aid Forms Submitted" },
                        { id: 3, name: "Not Admitted" },
                        { id: 4, name: "Attended an Application Interview" },
                        { id: 5, name: "Admitted" },
                        { id: 6, name: "Intend to Enroll" },
                        { id: 7, name: "Application Submitted" },
                        { id: 8, name: "Wait-listed" },
                    ]
                    this.reasons = [{ id: 1, name: "Close to home" },
                        { id: 2, name: "Good financial aid package" },
                        { id: 3, name: "Has always been my plan" },
                        { id: 4, name: "Far from home" },
                        { id: 5, name: "Friends go/plan to go there" },
                        { id: 6, name: "No financial aid package from first choice" },
                        { id: 7, name: "Can afford it" },
                        { id: 8, name: "Like the campus and environment" },
                        { id: 9, name: "Can meet the admission requirements" },
                        { id: 10, name: "Offers the program/major I want" },
                        { id: 11, name: "Right size for me" },
                        { id: 12, name: "Location" },
                        { id: 13, name: "Grads get good jobs" },
                        { id: 14, name: "Good academic reputation" },
                        { id: 15, name: "Athletics to play or watch" },
                        { id: 16, name: "Family member attended" }
                    ]

                });
        }

        checkTrackedAction(actionID: any, collegeActions: any) {
            var found = false;
            for (var i in collegeActions) {
                if (collegeActions[i].questionID == actionID)
                    found = true;
            }
            return found;
        }

        modifyTrackedAction(action: any, college: any, actions: any) {
            var found = false;
            for (var i in actions) {
                if (actions[i].questionID == action) {
                    found = true;
                    actions.splice(i, 1);
                }
            }
            if (!found) {
                var actionDict = _.keyBy(this.actions, 'id');
                var addedAction = actionDict[action];
                var data = { id: '', organizationID: college.organizationID, questionID: addedAction["id"], questionName: addedAction["name"] };
                actions.push(data);
            }
        }

        checkIntentReason(reasonID: any, intentReasons: any) {
            var found = false;
            for (var i in intentReasons) {
                if (intentReasons[i].reasonID == reasonID)
                    found = true;
            }
            return found;
        }

        modifyIntentReason(reason: any, intentInfo: any) {
            var found = false;
            for (var i in intentInfo) {
                if (intentInfo[i].reasonID == reason) {
                    found = true;
                    intentInfo.splice(i, 1);
                }
            }
            if (!found) {
                var reasonDict = _.keyBy(this.reasons, 'id');
                var addedReason = reasonDict[reason];
                var data = { id: '', reasonID: addedReason["id"], name: addedReason["name"] };
                intentInfo.push(data);
            }
        }

        getSavedSearches = () => {
            this.Restangular.one("collegePlanning/getsavedsearches").get().then((results) => {
                this.savedSearchComments = results.comments;
                for (var i = 0; i < results.searches.length; i++) {
                    if (!isNaN(i)) {
                        var test = results.searches[i];
                        var test1 = JSON.parse(test.search);
                        results.searches[i].search = test1;
                    }
                }
                this.savedSearchList = results.searches;
                this.noSavedSearches = results.searches.length == 0 ? true : false;
            }, (reason) => {
                console.error(reason);
            });
        }

        deleteSavedSearch = (search: any) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.one("collegePlanning/deleteSearch/" + search.id).remove().then((results) => {
                        this.getSavedSearches();
                        this.logSuccess("Your saved search changes have been saved", null, true);
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        loadSavedSearch(search: any) {
            sessionStorage.setItem("loadedSearch", search.name);
            sessionStorage.setItem("selectedSearch", JSON.stringify(search.search));
            this.$location.path("/campusSearch");
        }

        getSavedColleges = () => {
            this.Restangular.one("collegePlanning/getsavedcolleges").get().then((results) => {
                this.savedColleges = results.colleges;
                this.savedCollegeComments = results.comments;
                this.noSavedColleges = results.colleges.length == 0 ? true : false;
            }, (reason) => {
                console.error(reason);
            });
        }

        updateSavedCollege = (savedCollege: any, saveSection: string) => {
            if (saveSection == "Notes")
                savedCollege.notes = savedCollege.tempNotes;
            else if (saveSection == "CampusNotes")
                savedCollege.campusNotes = savedCollege.tempCampusNotes;
            else if (saveSection == "Actions")
                savedCollege.actions = _.clone(savedCollege.tempActions);
            else {
                savedCollege.notes = savedCollege.tempNotes;
                savedCollege.campusNotes = savedCollege.tempCampusNotes;
                savedCollege.actions = savedCollege.tempActions;
            }
            this.Restangular.all("collegePlanning/postsavedcollege").post(savedCollege).then((results) => {
                this.logSuccess("Your saved college changes have been saved", null, true);
            }, (reason) => {
                console.error(reason);
            });
        }

        deleteSavedCollege = (savedCollege: any, location: number) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.all("collegePlanning/deletesavedcollege").post(savedCollege).then((results) => {
                        console.log(results);
                        this.savedColleges.splice(location, 1);
                        this.logSuccess("Your saved college changes have been saved", null, true);
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        cancelTrackedActions(college: any) {
            college.tempActions = _.clone(college.actions);
        }

        getListofSchools = (baseString: string) => {
            var query = { startsWith: baseString };
            return this.Restangular.all("collegePlanning/getListofSchools").getList(query)
                .then((result) => {
                    return result;
                });
        };

        getIntentEnrollSchool = () => {
            var id;
            this.Restangular.one("collegePlanning/getintentenrollschool").get().then((results) => {
                this.intentEnrollSchoolInfo = results;
                this.intendedSchool = results.collegeName == "" || results.collegeName == null ? false : true;
                this.intendedCollegeName = this.intentEnrollSchoolInfo.collegeName;
                this.enrollList = !this.intendedSchool;
                this.enrollLoading = false;
                this.collegeReasons = false;
                id = results.organizationID;
            }, (reason) => {
                console.error(reason);
            });
        }

        editIntentEnroll() {
            this.intendedCollegeName = this.intentEnrollSchoolInfo.collegeName;
            this.identifyCollege = true;
            this.intendedSchool = false;
        }

        checkValidSchool(selectedSchool: string) {
            var query = { SelectedSchool: selectedSchool };
            this.Restangular.one("collegePlanning/verifyEnteredCollege").get(query).then((results) => {
                if (results) {
                    this.verifiedSchool = true;
                    this.collegeReasons = true;
                    this.identifyCollege = false;
                    if (this.intentEnrollSchoolInfo.collegeName != this.intendedCollegeName) {
                        this.intendedReasons = [];
                        this.intendedReasonNotes = "";
                    }
                    else {
                        this.intendedReasons = _.clone(this.intentEnrollSchoolInfo.reasons);
                        this.intendedReasonNotes = _.clone(this.intentEnrollSchoolInfo.reasonNotes);
                    }
                }
                else {
                    this.verifiedSchool = false;
                }
            }, (reason) => {
                console.error(reason);
            });
        }

        updateIntentEnrollSchool() {
            var school = { id: this.intentEnrollSchoolInfo.id, userID: 0, organizationID: "", hasCampusProfile: this.intentEnrollSchoolInfo.hasCampusProfile, campusURL: this.intentEnrollSchoolInfo.campusURL, collegeName: this.intendedCollegeName, collegeCity: "", savedDate: new Date(), reasonNotes: this.intendedReasonNotes, reasons: this.intendedReasons };
            this.Restangular.all("collegePlanning/updateintentenrollschool").post(school).then((results) => {
                this.logSuccess("Your intent to enroll changes have been saved", null, true);
                this.getIntentEnrollSchool();
            }, (reason) => {
                console.error(reason);
            });
        }

        clearIntentEnroll() {
            if (this.intentEnrollSchoolInfo.id != 0) {
                this.intendedSchool = true;
                this.collegeReasons = false;
            }
            else {
                this.collegeReasons = false;
                this.enrollList = true;
                this.intendedCollegeName = "";
                this.intendedReasons = [];
                this.intendedReasonNotes = "";
            }
        }

        getSavedProgramsMajors = () => {
            this.Restangular.one("collegePlanning/getsavedprograms").get().then((results) => {
                this.savedProgramsMajors = results.programs;
                this.savedProgramsComments = results.comments;
                this.chosenProgram = results.programs.length > 0 ? true : false;
                this.programList = !this.chosenProgram;
                this.showProgramNotes = true;
            }, (reason) => {
                console.error(reason);
            });
        }

        updateSavedProgram = (program: any) => {
            this.Restangular.all("collegePlanning/updatesavedprogram").post(program).then((results) => {
                this.logSuccess("Your saved program/major changes have been saved", null, true);
            }, (reason) => {
                console.error(reason);
            });
        }

        deleteSavedProgram = (program: any, location: number) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.one("collegePlanning/deletesavedprogram/" + program.id).remove().then((results) => {
                        this.getSavedProgramsMajors();
                        this.logSuccess("Your saved program/major changes have been saved", null, true);
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        getSelfReportedApps = () => {
            this.Restangular.one("collegePlanning/getselfreportedapps").get().then((results) => {
                this.showSelfApps = true;
                this.selfReportedApps = results.applications;
                this.selfReportedComments = results.comments;
                this.selfReportApp = results.applications.length > 0 ? true : false;
            }, (reason) => {
                console.error(reason);
            });
        }

        createNewSelfReportedApp() {
            this.selfReport = true;
            this.showSelfApps = false;
            this.selfReportID = 0;
            this.selfReportName = "";
            this.organizationID = null;
            this.srDate = new Date();
            var day = this.srDate.getDate();
            var month = this.srDate.getMonth() + 1;
            var year = this.srDate.getFullYear();
        }

        EditSelfReportApp(app: any, loc: number) {
            this.selfReport = true;
            this.showSelfApps = false;
            this.selfReportID = app.id;
            this.organizationID = app.organizationID;
            this.selfReportName = app.collegeName;
            this.selfReportCity = app.collegeCity;
            this.selfReportIndex = loc;
            this.srDate = new Date(app.submissionDate);
        }

        checkSchoolName(selectedSchool: string) {
            var query = { SelectedSchool: selectedSchool };
            this.Restangular.one("collegePlanning/verifyEnteredCollege").get(query).then((results) => {
                if (results) {
                    this.verifiedSelfReportSchool = true;
                    this.updateSelfReportedApp();
                }
                else {
                    this.verifiedSelfReportSchool = false;
                }
            }, (reason) => {
                console.error(reason);
            });
        }

        updateSelfReportedApp = () => {
            var finalDate;
            var test = typeof this.srDate;
            if (this.srDate instanceof Date) {
                var day = this.srDate.getDate();
                var month = this.srDate.getMonth() + 1;
                var year = this.srDate.getFullYear();
                finalDate = month + "-" + day + "-" + year;
            }
            if (test == "string") {
                finalDate = this.srDate;
            }
            var app = { id: this.selfReportID, organizationId: this.organizationID, userID: this.userID, collegeName: this.selfReportName, collegeCity: this.selfReportCity, submissionDate: finalDate };
            this.Restangular.all("collegePlanning/updateselfreportedapp").post(app).then((results) => {
                this.logSuccess("Your self-reported application changes have been saved", null, true);
                this.getSelfReportedApps();
                this.selfReportApp = true;
                this.selfReport = false;
                this.showSelfApps = true;
            }, (reason) => {
                console.error(reason);
            });
        }

        deleteSelfReportedApp = (app: any, location: number) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.all("collegePlanning/deleteselfreportedapp").post(app).then((results) => {
                        this.selfReportedApps.splice(location, 1);
                        this.selfReportApp = this.selfReportedApps.length == 0 ? false : true;
                        this.logSuccess("Your self-reported application changes have been saved", null, true);
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        getCollegeRecuiters = () => {
            this.Restangular.all("collegePlanning/getcollegerecruiters").getList().then((results) => {
                this.savedRecruiters = results;
                this.foundRecruiters = results.length > 0 ? true : false;
            }, (reason) => {
                console.error(reason);
            });
        }

        getTransitionPlan = () => {
            this.Restangular.one("collegePlanning/gettransitionplan").get().then((results) => {
                this.transitionPlan = results;
                this.loadTransition = false;
                if (results.id != 0) {
                    this.planList = false;
                    this.planSummary = true;
                    this.transitionPlan.planDescriptionNotes = this.transitionPlan.planDescriptionNotes == "" || this.transitionPlan.planDescriptionNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.planDescriptionNotes;
                    this.transitionPlan.careerGoalNotes = this.transitionPlan.careerGoalNotes == "" || this.transitionPlan.careerGoalNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.careerGoalNotes;
                    this.transitionPlan.supportNotes = this.transitionPlan.supportNotes == "" || this.transitionPlan.supportNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.supportNotes;
                    this.transitionPlan.nextTransitionNotes = this.transitionPlan.nextTransitionNotes == "" || this.transitionPlan.nextTransitionNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.nextTransitionNotes;
                    this.checkTransitionNotes();
                }
                else {
                    this.tempPathType = "Select a path...";
                    this.planList = true;
                }
            }, (reason) => {
                console.error(reason);
            });
        }

        checkTransitionNotes() {
            this.tempPlanDescriptionNotes = this.transitionPlan.planDescriptionNotes == "" || this.transitionPlan.planDescriptionNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.planDescriptionNotes;
            this.tempCareerGoalNotes = this.transitionPlan.careerGoalNotes == "" || this.transitionPlan.careerGoalNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.careerGoalNotes;
            this.tempSupportNotes = this.transitionPlan.supportNotes == "" || this.transitionPlan.supportNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.supportNotes;
            this.tempNextTransitionNotes = this.transitionPlan.nextTransitionNotes == "" || this.transitionPlan.nextTransitionNotes == null ? "Not entered! Select edit to add to your transition plan." : this.transitionPlan.nextTransitionNotes;
            this.tempPathType = this.transitionPlan.pathType;
        }

        cancelTransitionPlan() {
            this.createPlan = false;
            if (this.transitionPlan.id == 0) {
                this.planList = true;
                this.tempPlanDescriptionNotes = "";
                this.tempCareerGoalNotes = "";
                this.tempSupportNotes = "";
                this.tempNextTransitionNotes = "";
                this.tempPathType = "Select a path...";
            }
            else {
                this.planSummary = true;
                this.checkTransitionNotes();
            }
        }

        editTransitionPlan() {
            this.planSummary = false;
            this.createPlan = true;
            this.tempPlanDescriptionNotes = this.transitionPlan.planDescriptionNotes == "Not entered! Select edit to add to your transition plan." ? "" : this.transitionPlan.planDescriptionNotes;
            this.tempCareerGoalNotes = this.transitionPlan.careerGoalNotes == "Not entered! Select edit to add to your transition plan." ? "" : this.transitionPlan.careerGoalNotes;
            this.tempSupportNotes = this.transitionPlan.supportNotes == "Not entered! Select edit to add to your transition plan." ? "" : this.transitionPlan.supportNotes;
            this.tempNextTransitionNotes = this.transitionPlan.nextTransitionNotes == "Not entered! Select edit to add to your transition plan." ? "" : this.transitionPlan.nextTransitionNotes;
            this.tempPathType = this.transitionPlan.pathType;
        }

        saveTransitionPlan = () => {
            var transitionPlan = { id: this.transitionPlan.id, pathType: this.tempPathType, planDescriptionNotes: this.tempPlanDescriptionNotes, careerGoalNotes: this.tempCareerGoalNotes, supportNotes: this.tempSupportNotes, nextTransitionNotes: this.tempNextTransitionNotes, savedDate: new Date() };
            this.Restangular.all("collegePlanning/updatetransitionplan").post(transitionPlan).then((results) => {
                this.getTransitionPlan();
                this.logSuccess("Your high school transition plan changes have been saved", null, true);
            }, (reason) => {
                console.error(reason);
            });
        }

        deleteTransitionPlan = (plan: any) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.Restangular.all("collegePlanning/deletetransitionplan").post(this.transitionPlan).then((results) => {
                        this.logSuccess("Your high school transition plan changes have been saved", null, true);
                        this.planList = true;
                        this.planSummary = false;
                        this.transitionPlan.id = 0;
                        this.transitionPlan.pathType = "Select a path...";
                        this.transitionPlan.planDescriptionNotes = "";
                        this.transitionPlan.careerGoalNotes = "";
                        this.transitionPlan.supportNotes = "";
                        this.transitionPlan.nextTransitionNotes = "";
                        this.transitionPlan.savedDate = "";
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        getPersonalStatements = () => {
            this.Restangular.one("collegePlanning/getpersonalstatements").get().then((results) => {
                this.personalStatements = results;
                if (this.personalStatements.draftStatement == "" || this.personalStatements.draftStatement == "None Saved") {
                    this.uploadedDraft = false;
                }
                else
                    this.uploadedDraft = true;
                if (this.personalStatements.finalStatement == "" || this.personalStatements.finalStatement == "None Saved") {
                    this.uploadedFinal = false;
                }
                else
                    this.uploadedFinal = true
                this.loadPersonal = false;
            }, (reason) => {
                console.error(reason);
            });
        }

        testresult = (result: string): any => {
            var test = result;
        }

        upload(fileType: string) {
            this.Upload.upload({
                url: this.config.apiHost + "/collegePlanning/UploadPersonalStatement/" + fileType,
                method: "POST",
                file: fileType == "draft" ? this.draftFile : this.finalFile
            }).success((data, status, headers, config) => {
                this.logSuccess("Your personal statement changes have been saved", null, true);
                this.getPersonalStatements();
            }).error((data, status, headers, config) => {
                console.error(data);
            });
        }

        deletePersonalStatement = (type: any) => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    var data;
                    if (type == "draft") {
                        data = { id: this.personalStatements.id, deleteDraft: true, deleteFinal: false };
                    }
                    else {
                        data = { id: this.personalStatements.id, deleteDraft: false, deleteFinal: true };
                    }
                    this.Restangular.all("collegePlanning/deletepersonalstatement").post(data).then((results) => {
                        if (type == "draft") {
                            this.personalStatements.draftStatement = "None Saved";
                            this.uploadedDraft = false;
                            $("#draftFileUpload").val('')
                        }
                        else {
                            this.personalStatements.finalStatement = "None Saved";
                            this.uploadedFinal = false;
                            $("#finalFileUpload").val('')
                        }
                        this.logSuccess("Your personal statement changes have been saved", null, true);
                    }, (reason) => {
                        console.error(reason);
                    });
                }
            });
        }

        getPersonalStatementFile = (fileType: string) => {
            this.Restangular.one("collegePlanning/getStatementFile").get(fileType).then((results) => {
                this.helper.openFile(this.config.apiHost + "/download", results);
            }, (reason) => {
                console.error(reason);
            });
        }

        print = ($event) => {
            this.pdfButtonDisable = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html><head>" + headHtml + "</head><body style='margin: 50px; background-color: #fff; background-image:none'>" + $event.currentTarget.parentElement.parentElement.innerHTML + "</body></html>";
            this.helper.openFile(this.config.apiHost + "/pdf/download", { html: encodeURIComponent(html), url: location.origin }).then(() => {
                this.pdfButtonDisable = false;
            });

        };

        email = ($event) => {
            this.emailButtonDisable = true;
            var location: any = window.location;
            var headHtml = "";
            $(this.$document[0]["head"]).children("link").each((i: number, l: any) => {
                headHtml += l.outerHTML;
            });
            var html = "<html>" + headHtml + "<body style='margin: 50px; background-color: #fff; background-image:none'>" + $event.currentTarget.parentElement.parentElement.innerHTML + "</body></html>";
            this.Restangular.all("pdf").all("email").post({ html: encodeURIComponent(html), url: location.origin })
                .then((response) => {
                    this.emailButtonDisable = false;
                    this.logSuccess("Email has been sent to the email address associated with your CFNC profile.", "Email has been sent to the email address associated with your CFNC profile.", true);
                }, (reason) => {
                    console.log(reason);
                    this.logError("There was a problem sending your email. Please try again later.", reason, true);
                }, (state) => {
                });
        }
        
    }

    angular.module("app").controller(CollegePlanning.controllerId, CollegePlanning);
}